"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                Input_CurrentValue: "Current value:",
                Input_Disabled: "Disabled",
                Input_ExecuteHyperlink: "Execute hyperlink",
                Input_FollowLink: "{0}\r\nClick to follow link",
                Input_InvalidValue: "'{0}' is not a valid value.",
                Input_LastValue: "Last valid value:",
                Input_LookupAriaLabel: "Open lookup",
                Input_LookupHelpText: "(Alt+Down)",
                Input_LookupTooltip: "Open",
                Input_OpenContextMenu: "Open context menu",
                Input_OpenDropDown: "Open drop down",
                Input_OpenEnhancedPreview: "Open enhanced preview",
                Input_PresenceAvailable: "Presence Available",
                Input_PresenceAway: "Presence Away",
                Input_PresenceBeRightBack: "Presence Be Right Back",
                Input_PresenceBusy: "Presence Busy",
                Input_PresenceDoNotDisturb: "Presence Do Not Disturb",
                Input_PresenceOffline: "Presence Offline",
                Input_PresenceUnknown: "Presence Unknown",
                Input_Readonly: "Readonly",
                Input_SelectValueFromLookup: "When using lookups in a recording intended for a task guide, ALWAYS open and select a value from the lookup (instead of typing in a value directly) for an optimal task guide experience.",
                Input_SkypeShortcut: "Skype shortcut",
                Lookup_SelectedItemState: "selected",
                No_LabelFound: "Missing label",
            }
        });
        var InputValueBinder = /** @class */ (function () {
            function InputValueBinder(context) {
                this.context = context;
            }
            InputValueBinder.prototype.shouldExecute = function (event, allowEnter) {
                // If we should continue with the setValue on enter
                var shouldExecute = false;
                if (!allowEnter && $dyn.util.isShortcutKeyPressed(event, { keyCode: $dyn.ui.KeyCodes.enter })) {
                    // If the lookup is opened and ready then let the lookup handle the selection via enter.
                    var control = this.context;
                    if (this.context.ReferenceGroup) {
                        control = this.context.ReferenceGroup;
                    }
                    var controlAsPopupHost = control;
                    shouldExecute = (!control.SendKeyToLookup ||
                        !$dyn.value(control.ShowFlyout) ||
                        !$dyn.context(controlAsPopupHost.popupHostElement) ||
                        !$dyn.value($dyn.context(controlAsPopupHost.popupHostElement).IsFormReady));
                }
                return shouldExecute;
            };
            InputValueBinder.prototype.performCleanup = function () {
                if (this.context.focusOutCleanup) {
                    // Perform state cleanup that would happen when focus is lost by the control. This will reset pending timers that depend on the
                    // value not having been sent to the server.
                    this.context.focusOutCleanup();
                }
            };
            InputValueBinder.prototype.getValue = function () {
                return this.context.formattedValue();
            };
            InputValueBinder.prototype.setValue = function (newValue, forceChange) {
                this.context.formattedValue(newValue, forceChange);
            };
            InputValueBinder.prototype.notifyCommitted = function () {
                // Let the binding handler know that the control has already taken care of the setValue
            };
            InputValueBinder.prototype.preventForceChange = function () {
                // Do not do a force change on the formatted value for a focused lookup, as we want to filter in that case
                return this.context && $dyn.value(this.context.LookupButton) && $dyn.value(this.context.isFocused);
            };
            return InputValueBinder;
        }());
        controls.InputValueBinder = InputValueBinder;
        /**
         * Base class for different types of Input controls
         */
        var BaseInput = /** @class */ (function (_super) {
            __extends(BaseInput, _super);
            function BaseInput() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                /**
                 * The input event handler
                 */
                _this.onInput = function () {
                    _this.callTextChanged();
                };
                return _this;
            }
            BaseInput.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.$inputElement = this.$cachedElement.find("input");
                // There are different layers to the "value" of an input control
                // 1. uncommitted value deals with a lookup where we don't want to submit the value
                //    when we change focus to the lookup, but we don't want to lose the value either.
                // 2. formattedValue is what the html control is showing to the user
                //    _lastUserValue for Number and Date controls are the last user entered value
                //    _parsedValue is the last user entered value after parsing
                // 3. Value is the value that is committed to the control, should stay in sync with server control
                //
                // The sequence of interactions that happen when we change the value on an input control:
                // 1. Client sends a SetValue command interaction to the server
                // 2. Server returns with an updateModel/updateViewModel interaction if value passed validateAndModify
                //      -This is what updates the Value property on the control
                // 3. Server returns a callback of success if it passed validateAndModify or fail otherwise
                //      -If success we should make sure that the _parsedValue and Value are in sync, if not then update the _parsedValue and formattedValue
                //
                // There are two different types of validation, client and server:
                // 1. If you fail client-side validation (i.e. NaN in number control, negative in allowNegative=No, wrong date format, etc.),
                //    we immediately make the client-side control invalid, and update the server using the IsValid property trigger.
                // 2. To get that control valid again, the user would have to enter a value that passes client-side validation AND server-side.
                //    In CallValidateAndModify on the server we update the IsValid property, which would get sent down to the client.
                //    (Note: Other ways to make control valid, delete/restore on bound controls.)
                this.conditionalLimitTextLength = $dyn.computed(function () {
                    var showLookup = $dyn.value(_this.LookupButton);
                    if (showLookup) {
                        // Lookup controls allow a user to enter data in a more descriptive manner--say using a Name instead of an ID (with the
                        // "name" getting maped to an ID). Since the descriptive names can be much longer than the ID that would normally be entered
                        // we must disable maxLength enforcement. Note that this is ok because lookups/FKs are validated by the server--meaning that
                        // a string that is too long will not map to a value in the domain and be appropriately rejected.
                        // It is possible to properly compute the LimitText in this case on the server. However, there would be non-trivial overhead
                        // during form load time to do so.
                        return 0;
                    }
                    else {
                        return $dyn.value(_this.LimitText);
                    }
                });
                this.formattedValue = $dyn.computed(function () {
                    if ($dyn.peek(_this.LookupButton) && $dyn.peek(_this.isFocused) && _this.uncommittedValue !== undefined) {
                        // Note isFocused is only used by lookups, so this should not impact non-lookup control perf.
                        return _this.uncommittedValue;
                    }
                    return _this.getFormattedValue();
                }, function (newValue, forceChange) {
                    // Consider making _parsedValue an property so this is not needed.
                    _this.updatingBlock(function () {
                        if (!forceChange && $dyn.peek(_this.LookupButton) && $dyn.peek(_this.isFocused)) {
                            // If there is focus still in the control/lookup prevent the value from being set, but allow the value to be used to filter the lookup
                            _this.uncommittedValue = newValue;
                        }
                        else {
                            _this.setFormattedValue(newValue, forceChange);
                            _this.uncommittedValue = undefined;
                        }
                        if ($dyn.peek(_this.Required)) {
                            // Mandatory requirements could have been met
                            _this.UpdateStatusArea();
                        }
                    });
                });
                this.Text = this.formattedValue;
                this.showLink = $dyn.computed(function () {
                    var showLink = ($dyn.value(_this.IsHyperlink) &&
                        $dyn.value(_this.Enabled) &&
                        $dyn.value(_this.IsValid) &&
                        !$dyn.value(_this.isValueEmpty) &&
                        !$dyn.value(_this.LookupOnly));
                    if (showLink && $dyn.value(_this.AllowEdit) && _this.Root) {
                        // we need to check for active control and focused for when the control
                        // is active but is not focused (click the body or closing a flyout will
                        // leave the control active but not focused)
                        if (_this.Root.isActiveControl(_this.Name) && $dyn.value(_this.isFocused)) {
                            showLink = false;
                        }
                    }
                    if (_this.ReferenceGroup) {
                        showLink = showLink && $dyn.value(_this.ReferenceGroup.IsValid);
                    }
                    return showLink;
                });
                this.readOnly = $dyn.computed(function () {
                    return !$dyn.value(_this.AllowEdit);
                });
                this.isValueEmpty = $dyn.computed(function () {
                    return ($dyn.value(_this.formattedValue) == null || $dyn.value(_this.formattedValue) === "") ? true : false;
                });
                this.toolTip = $dyn.computed(function () {
                    // If helptext has a left parenthesis at the beginning, it is assumed that a keyboard shortcut is declared as part of the helptext.
                    // Shortcut should be displayed alongside the label on the tooltip. Rest of the helptext description should be on a new line.
                    var toolTip = "";
                    if ($dyn.value(_this.showToolTip) && !$dyn.value(_this.PasswordMode)) {
                        var value_1 = $dyn.value(_this.formattedValue);
                        if (!_this.controlIsValid()) {
                            var lastValue = _this.lastValidFormattedValue();
                            var valueString = $dyn.format("{0} {1}\n{2} {3}", $dyn.label("Input_LastValue"), lastValue, $dyn.label("Input_CurrentValue"), value_1);
                            if ((_this.messages && _this.messages.length && !$dyn.value(_this.IsValid)) ||
                                (_this.ReferenceGroup && _this.ReferenceGroup.messages && _this.ReferenceGroup.messages.length && !$dyn.value(_this.ReferenceGroup.IsValid))) {
                                toolTip = _this.getMessageString() + "\n\n" + valueString;
                            }
                            else {
                                toolTip = valueString;
                            }
                        }
                        else if ($dyn.value(_this.HasMessages) || (_this.ReferenceGroup && $dyn.value(_this.ReferenceGroup.HasMessages))) {
                            toolTip = _this.getMessageString();
                        }
                        else if (value_1) {
                            if (_this.showLink() || _this.DefaultActionEnabled) {
                                toolTip = $dyn.format($dyn.label("Input_FollowLink"), value_1);
                            }
                            else {
                                toolTip = value_1;
                            }
                        }
                        var presenceSuffix = void 0;
                        switch ($dyn.value(_this.Presence)) {
                            case $dyn.skypeInteraction.PresenceType.Online:
                                presenceSuffix = $dyn.label("Input_PresenceAvailable");
                                break;
                            case $dyn.skypeInteraction.PresenceType.Offline:
                                presenceSuffix = $dyn.label("Input_PresenceOffline");
                                break;
                            case $dyn.skypeInteraction.PresenceType.Away:
                                presenceSuffix = $dyn.label("Input_PresenceAway");
                                break;
                            case $dyn.skypeInteraction.PresenceType.BeRightBack:
                                presenceSuffix = $dyn.label("Input_PresenceBeRightBack");
                                break;
                            case $dyn.skypeInteraction.PresenceType.Busy:
                                presenceSuffix = $dyn.label("Input_PresenceBusy");
                                break;
                            case $dyn.skypeInteraction.PresenceType.DoNotDisturb:
                                presenceSuffix = $dyn.label("Input_PresenceDoNotDisturb");
                                break;
                            case $dyn.skypeInteraction.PresenceType.Unknown:
                                presenceSuffix = $dyn.label("Input_PresenceUnknown");
                                break;
                        }
                        if (presenceSuffix) {
                            toolTip += "\n" + presenceSuffix;
                        }
                    }
                    return toolTip;
                });
                this.allowTyping = $dyn.computed(function () {
                    return $dyn.value(_this.AllowEdit) && !$dyn.value(_this.LookupOnly);
                });
                $dyn.observe($dyn.options(function () {
                    return { isEmptyPassword: _this.IsEmptyPassword, passwordMode: _this.PasswordMode };
                }, this.Updating), function () {
                    _this.updatingBlock(function () {
                        _this.updateParsedValue($dyn.value(_this.Value));
                    });
                });
                $dyn.observe(this.LayoutWidth, function (newValue) {
                    // This is needed because when for fill-width flex elements (SizeToAvailable), flexbox assigns the default browser size for an input tag to be
                    // 20. This is the smallest that the fill-width element will be allowed to get by the flexbox CSS. Setting the size attribute to '1' will allow
                    // the field to be sized to the minimum that it can, however, it will never get smaller than 1 character in size.
                    if (_this.$inputElement && _this.$inputElement.length) {
                        var currentSize = _this.$inputElement[0].getAttribute("size");
                        if (newValue === $dyn.layout.Size.available) {
                            _this.$inputElement[0].setAttribute("size", "1");
                        }
                        else if (currentSize && currentSize !== "") {
                            _this.$inputElement[0].setAttribute("size", "");
                        }
                    }
                });
                $dyn.observe(this.Value, function (newValue) {
                    // If value was set not going through setFormattedValue, update formattedValue
                    if (!_this.compareToParsedValue(newValue)) {
                        _this.updatingBlock(function () {
                            // If messages weren't cleared in setFormatted value, do it here
                            // Possible if the value is getting set programtically
                            _this.removeMessages();
                            _this.updateParsedValue(newValue);
                            if (_this.uncommittedValue !== undefined) {
                                _this.uncommittedValue = _this.getFormattedValue();
                            }
                            _this.formattedValue.valueChanged.raise();
                            if ($dyn.value(_this.Required) || (_this.ReferenceGroup && $dyn.value(_this.ReferenceGroup.Required))) {
                                // Mandatory met condition could have changed
                                _this.UpdateStatusArea();
                            }
                        });
                    }
                });
                if (!this.isInactiveCell()) {
                    $dyn.observe(this.IsValid, function (newValue) {
                        _this.updatingBlock(function () {
                            if (_this.Root && _this.Root.UpdateInvalidControlList) {
                                _this.Root.UpdateInvalidControlList(_this);
                            }
                            if (newValue) {
                                // Becoming valid we should always show a valid value and remove any old validation messages
                                _this.removeMessages();
                                if (!_this.compareToParsedValue($dyn.value(_this.Value))) {
                                    _this.updateParsedValue($dyn.value(_this.Value));
                                }
                                // formattedValue could show different value based on of the control is valid
                                _this.formattedValue.valueChanged.raise();
                            }
                            _this.UpdateStatusArea();
                        });
                    });
                    $dyn.observe(this.AllowEdit, function (newValue) {
                        if ($dyn.value(_this.IsValid) && !newValue) {
                            var hasFocus_1 = $dyn.value(_this.isFocused);
                            _this.updatingBlock(function () {
                                if ($dyn.value(_this.ShowFlyout)) {
                                    if ($dyn.log.popups) {
                                        $dyn.log.popups("Popups: AllowEdit set to false on %s / %s; setting ShowFlyout to false", _this.Name ? _this.Name : "<unknown>", (_this._element && _this._element.id) ? _this._element.id : "<unknown>");
                                    }
                                    $dyn.setValue(_this, "ShowFlyout", false);
                                }
                                var updateFormattedValue = false;
                                if (!_this.compareToParsedValue($dyn.value(_this.Value))) {
                                    _this.updateParsedValue($dyn.value(_this.Value));
                                    updateFormattedValue = true;
                                }
                                if (hasFocus_1) {
                                    // Notify the value binding handler that it can no longer be updating
                                    _this.valueBinder.notifyCommitted();
                                    updateFormattedValue = true;
                                }
                                if (updateFormattedValue) {
                                    _this.formattedValue.valueChanged.raise();
                                }
                            });
                        }
                        if ($dyn.value(_this.Required) || (_this.ReferenceGroup && $dyn.value(_this.ReferenceGroup.Required))) {
                            _this.UpdateStatusArea();
                        }
                    });
                    $dyn.observe(this.Enabled, function (newValue) {
                        if ($dyn.value(_this.IsValid) && !newValue) {
                            var hasFocus_2 = $dyn.value(_this.isFocused);
                            _this.updatingBlock(function () {
                                if ($dyn.value(_this.ShowFlyout)) {
                                    if ($dyn.log.popups) {
                                        $dyn.log.popups("Popups: Enabled set to false on %s / %s; setting ShowFlyout to false", _this.Name ? _this.Name : "<unknown>", (_this._element && _this._element.id) ? _this._element.id : "<unknown>");
                                    }
                                    $dyn.setValue(_this, "ShowFlyout", false);
                                }
                                var updateFormattedValue = false;
                                if (!_this.compareToParsedValue($dyn.value(_this.Value))) {
                                    _this.updateParsedValue($dyn.value(_this.Value));
                                    updateFormattedValue = true;
                                }
                                if (hasFocus_2) {
                                    _this.valueBinder.notifyCommitted();
                                    updateFormattedValue = true;
                                    if (_this.Root && _this.Root.element) {
                                        var tabbableElements = $(_this.Root.element).find(":tabbable");
                                        var index = tabbableElements.index(_this.$inputElement[0]);
                                        if (index > -1) {
                                            index = index % tabbableElements.length;
                                            tabbableElements.eq(index + 1).focus();
                                            tabbableElements.eq(index + 1).select();
                                        }
                                    }
                                }
                                if (updateFormattedValue) {
                                    _this.formattedValue.valueChanged.raise();
                                }
                            });
                        }
                        if ($dyn.value(_this.Required) || (_this.ReferenceGroup && $dyn.value(_this.ReferenceGroup.Required))) {
                            _this.UpdateStatusArea();
                        }
                    });
                    $dyn.observe(this.SipAddress, function (newSipAddress) {
                        if (!_this.isInGrid() && newSipAddress !== _this._cachedSipAddress && (newSipAddress || _this._cachedSipAddress)) {
                            // When the SIP address changes, unregister and re-register the control with Skype
                            if (_this._cachedSipAddress) {
                                $dyn.skypeInteraction.unregisterControl(_this._cachedSipAddress, _this);
                            }
                            _this._cachedSipAddress = newSipAddress;
                            if (newSipAddress) {
                                $dyn.skypeInteraction.registerControl(newSipAddress, _this);
                            }
                        }
                    });
                }
                if (this.CustomPopup) {
                    this.showPopup = this.CustomPopup;
                }
                else {
                    $dyn.ui.popupHost.apply(this);
                }
                var clientState = $dyn.value(this.ClientState);
                if (clientState && typeof (clientState) === "string") {
                    // We will only parse clientState if it's a string
                    if (this.applyClientState) {
                        var clientStateAsObj_1 = JSON.parse(clientState);
                        // Something was set on the server as client-only state.
                        // Do an async call to process this value.
                        $dyn.async(function () {
                            _this.applyClientState(clientStateAsObj_1);
                        }, undefined, "Apply client state");
                    }
                }
                this.EnhancedTypeAhead = $dyn.computed(function () {
                    return $dyn.value(_this.ReplaceOnLookup) === false && $dyn.value(_this.ShowFlyout) === true;
                });
                $dyn.observe(this.ReplaceOnLookup, function (replaceOnLookup) {
                    if (replaceOnLookup) {
                        $(_this.element).find(".lookupButton").removeClass("replaceOnLookupNo");
                    }
                    else {
                        $(_this.element).find(".lookupButton").addClass("replaceOnLookupNo");
                    }
                });
                $dyn.observe(this.EnhancedTypeAhead, function (flyoutOpen) {
                    if (flyoutOpen) {
                        // The user is opening the flyout
                        var displayedValueSource = _this.getDisplayedValueSource();
                        if (displayedValueSource) {
                            // Store the value of what's currently in the field.
                            _this._enhancedTypeAheadValue = displayedValueSource.displayedValue();
                            if (displayedValueSource.$inputElement && displayedValueSource.$inputElement[0]) {
                                // Store the cursor position at the time the lookup is opened.
                                _this._enhancedTypeAheadSelectionStart = $dyn.ui.selectionStart(displayedValueSource.$inputElement[0]);
                                _this._enhancedTypeAheadSelectionEnd = $dyn.ui.selectionEnd(displayedValueSource.$inputElement[0]);
                            }
                        }
                        // Reset the filter on the flyout
                        _this.queueFilterFlyout(0, "");
                    }
                    else {
                        delete _this._previousFilterValue;
                    }
                });
            };
            Object.defineProperty(BaseInput.prototype, "valueBinder", {
                /**
                 * The value binder used in the boundValue binding handler
                 */
                get: function () {
                    if (!this._valueBinder) {
                        this._valueBinder = new InputValueBinder(this);
                    }
                    return this._valueBinder;
                },
                enumerable: false,
                configurable: true
            });
            BaseInput.prototype.getLabelledByData = function () {
                if (this.ReferenceGroup) {
                    return {
                        byElementId: this.ReferenceGroup.Id + "_label",
                        isInGrid: this.ReferenceGroup.isInGrid(),
                        label: $dyn.value(this.ReferenceGroup.Label),
                        showLabel: $dyn.value(this.ReferenceGroup.ShowLabel),
                    };
                }
                return {
                    byElementId: this.Id + "_label",
                    isInGrid: this.isInGrid(),
                    label: $dyn.value(this.Label),
                    showLabel: $dyn.value(this.ShowLabel),
                };
            };
            /**
             * Determine if the control is dirty
             * @returns Whether or not the displayed value is different than the backing value
             */
            BaseInput.prototype.isDisplayedValueDirty = function () {
                var baseValue = this._formatAsDisplayValue($dyn.value(this.Value));
                var displayedValue = this.displayedValue();
                return displayedValue !== baseValue;
            };
            /**
             * Sync the parsedValue and formattedValue to backing value
             */
            BaseInput.prototype.syncValues = function () {
                var _this = this;
                this.updatingBlock(function () {
                    // Force formattedValue to update
                    _this.updateParsedValue($dyn.value(_this.Value));
                    _this.uncommittedValue = undefined;
                    _this.formattedValue.valueChanged.raise();
                });
            };
            /**
             * Update the formatted value to the new value
             * @param newValue The value to set the formattedValue to
             */
            BaseInput.prototype.updateFormattedValue = function (newValue) {
                var _this = this;
                this.updatingBlock(function () {
                    _this.updateLastUserValue(newValue);
                    _this.uncommittedValue = undefined;
                    _this.updateParsedValue(newValue);
                    _this.formattedValue.valueChanged.raise();
                });
                this.valueBinder.notifyCommitted();
            };
            BaseInput.prototype.isMandatoryMet = function () {
                var met = true;
                if ($dyn.value(this.formattedValue) == null || $dyn.value(this.formattedValue) === "") {
                    met = false;
                }
                return met;
            };
            BaseInput.prototype.FindFocusTarget = function () {
                return this.$inputElement;
            };
            /**
             * Open the lookup if editable and lookuponly when clicking the input element
             */
            BaseInput.prototype.onInputClick = function () {
                // LookupOnly fields should launch their lookup when the input is clicked.
                if (this.allowUserChanges() && $dyn.value(this.LookupOnly)) {
                    // Click the lookupButton so the flyout click handler is run
                    var $lookupButton = this.$cachedElement.find(".lookupButton");
                    if ($lookupButton.length === 1) {
                        $lookupButton.click();
                    }
                }
            };
            /**
             * The keydown event handler
             * @param evt The keydown event
             */
            BaseInput.prototype.keyDown = function (evt) {
                $dyn.util.handleShortcuts(this, evt);
                this.disableAutoPresentLookupForQuickEditGrids();
                this.autoPresentLookup(evt);
            };
            /**
             * The keyup event handler
             * @param evt The keyup event
             */
            BaseInput.prototype.keyUp = function (evt) {
                var lookupInteractionTarget;
                if (this.ReferenceGroup && this.ReferenceGroup.getLookupInteractionTarget) {
                    lookupInteractionTarget = this.ReferenceGroup.getLookupInteractionTarget();
                }
                else {
                    lookupInteractionTarget = this.getLookupInteractionTarget();
                }
                var lookupInteractionTargetContext = $dyn.context(lookupInteractionTarget);
                if (lookupInteractionTargetContext && lookupInteractionTargetContext.Root && lookupInteractionTargetContext.Root.UseReactGrid()) {
                    lookupInteractionTargetContext.keyUp(evt);
                }
            };
            /**
             * Update the control value with the DOM element value.
             * @param callResolveChanges Whether we should call resolve changes on the parent reference group if applicable
             * @param forceChange Whether to pass force change into the setting of the formatted value
             * @param onlyCheckForValueChanged Only check if the value is dirty on the control and do not update the value
             * @returns Whether or not the control was dirty
             */
            BaseInput.prototype.updateValue = function (callResolveChanges, forceChange, onlyCheckForValueChanged) {
                if (callResolveChanges === void 0) { callResolveChanges = false; }
                if (forceChange === void 0) { forceChange = false; }
                if (onlyCheckForValueChanged === void 0) { onlyCheckForValueChanged = false; }
                // Required for controls that do not immediately update the control value to raise property changes with each user interaction
                // Specialized controls may need to overwrite this function.
                // Update the observable with the current value from the DOM element.
                // Take this action even if there is no change, to allow the framework to react to the $dyn.ui.ChangeMode value
                // We have chosen not to use the .blur event, as we may not actually change the focus in the DOM. (e.g. browser back button or ctrl-s)
                // Don't allow to update value if control is read only
                var valueChanged = false;
                if (this.allowUserChanges()) {
                    valueChanged = this.isDisplayedValueDirty();
                    if (!onlyCheckForValueChanged) {
                        var newValue = this.displayedValue();
                        if (this.ReferenceGroup && this.ReferenceGroup.isFocused()) {
                            this.formattedValue(newValue, forceChange);
                            if (callResolveChanges) {
                                this.ReferenceGroup.resolveChanges();
                            }
                        }
                        else if ($dyn.value(this.LookupButton) && this.isFocused()) {
                            // Bypass the lookup's special case save logic that prevents saving focused controls.
                            this.setFormattedValue(newValue, forceChange);
                            this.uncommittedValue = undefined;
                        }
                        else {
                            this.formattedValue(newValue, forceChange);
                        }
                        this.valueBinder.notifyCommitted();
                    }
                }
                return valueChanged;
            };
            /** @obsolete */
            BaseInput.prototype.cellRenderer = function (rowIndex) {
                return {
                    value: this.Value && this.Value.virtualizer ? this.Value.virtualizer(rowIndex) : $dyn.value(this.Value),
                };
            };
            /**
             * Update the backing value
             * @param newValue What to set the value property to
             * @param forceChange Whether to update the value property even if it hasn't changed
             * @param forceCommandCall Whether to call SetValue command no matter what
             * @returns A promise that gets resolved when the value setting process is completed
             */
            BaseInput.prototype.setValue = function (newValue, forceChange, forceCommandCall) {
                var _this = this;
                if (forceChange === void 0) { forceChange = false; }
                if (forceCommandCall === void 0) { forceCommandCall = false; }
                var result = $.Deferred();
                var allowUserChanges = this.allowUserChanges();
                if ((forceCommandCall || allowUserChanges) && (forceChange || !$dyn.value(this.IsValid) || newValue !== $dyn.value(this.Value))) {
                    if (this.SetValue) {
                        var commandCallback_1 = function (success) {
                            if (success) {
                                if (!_this.compareToParsedValue($dyn.value(_this.Value))) {
                                    _this.syncValues();
                                }
                            }
                            result.resolve();
                        };
                        var failureCallback_1 = function () {
                            // true will force a sync of the value
                            commandCallback_1(true);
                        };
                        // Users should always select the value from the lookup (rather than typing) when recording scenarios for task guides.
                        var issueValueSelectionWarning = ($dyn.value(this.LookupButton) &&
                            this.TypeName !== "Date" &&
                            $dyn.value($dyn.ax.taskRecording.isRecording) &&
                            !$dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState));
                        if (issueValueSelectionWarning) {
                            $dyn.info({ Message: $dyn.label("Input_SelectValueFromLookup"), Label: "Input_SelectValueFromLookup" });
                        }
                        if ($dyn.serverForm && $dyn.peek($dyn.serverForm.processingInteractions)) {
                            // Subscribe to $dyn.serverForm.processingInteractions to avoid SetValue being dropped
                            var subscriberId_1 = $dyn.serverForm.processingInteractions.valueChanged.subscribe(function () {
                                $dyn.callFunction(_this.SetValue, _this, [newValue], commandCallback_1, null /*complete*/, null /*before*/, null /*throttle*/, failureCallback_1);
                                $dyn.serverForm.processingInteractions.valueChanged.unsubscribe(subscriberId_1);
                            });
                        }
                        else {
                            $dyn.callFunction(this.SetValue, this, [newValue], commandCallback_1, null /*complete*/, null /*before*/, null /*throttle*/, failureCallback_1);
                        }
                    }
                    else {
                        $dyn.setValue(this, "Value", newValue, forceChange);
                        this.IsValid(true);
                        result.resolve();
                    }
                }
                else {
                    var failed = !allowUserChanges;
                    result.resolve(failed);
                }
                return result;
            };
            BaseInput.prototype.GetState = function () {
                // todo: Check against value?
                var formattedValue = this.getFormattedValue();
                return {
                    formattedValue: formattedValue !== null && formattedValue !== undefined ? formattedValue : ""
                };
            };
            BaseInput.prototype.ApplyState = function (clientState) {
                var _this = this;
                if (clientState.messages && clientState.messages.length > 0) {
                    this.messages = clientState.messages;
                }
                if (clientState.formattedValue !== undefined) {
                    // Update the formatted value if it's different from the one stored in the Client State on the server
                    if (clientState.formattedValue !== this.getFormattedValue()) {
                        var result = this.setFormattedValue(clientState.formattedValue, true, true);
                        this.UpdateStatusArea();
                        var retVal_1 = $.Deferred();
                        result.done(function (value) {
                            if ($dyn.value(_this.IsValid)) {
                                retVal_1.resolve(value);
                            }
                            else {
                                retVal_1.reject();
                            }
                        });
                        return retVal_1;
                    }
                }
            };
            BaseInput.prototype.onSerializeTransitState = function () {
                // Send our formattedValue to the server so that it can be deserialized later.
                var clientState = JSON.stringify({
                    formattedValue: this.getFormattedValue()
                });
                // Set ClientState
                $dyn.setValue(this, "ClientState", clientState);
            };
            // obsolete?
            BaseInput.prototype.GetInitialState = function () {
                return { formattedValue: "" };
            };
            BaseInput.prototype.OnKeyboardSecondaryNavigation = function () {
                this.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
            };
            BaseInput.prototype.OnMouseSecondaryNavigation = function () {
                this.TelemetryOptions = { inputType: $dyn.telemetry.InputType.mouse };
            };
            BaseInput.prototype.dispose = function () {
                if (this._cachedSipAddress) {
                    $dyn.skypeInteraction.unregisterControl(this._cachedSipAddress, this);
                }
                _super.prototype.dispose.call(this);
            };
            BaseInput.prototype.attached = function () {
                _super.prototype.attached.call(this);
                this.$inputElement = this.$cachedElement.find("input");
                if (this._) {
                    this._.input = $("input", this.element)[0];
                }
            };
            /**
             * Returns if control can log message.
             * @param userValue new value entered by user
             * @returns false if control should not log message
             */
            BaseInput.prototype.shouldControlLogMessage = function (userValue) {
                var sameText = false;
                var logMessages = false;
                if (this._lastUserValue === userValue) {
                    sameText = true;
                }
                // To force validation if we can see last validation was false for the same text and messages are cleared by some other flow.
                var forceValidation = false;
                if (sameText && this._lastValidationResult === false && this.messages && this.messages.length === 0) {
                    forceValidation = true;
                }
                if (!sameText || forceValidation) {
                    logMessages = true;
                }
                return logMessages;
            };
            BaseInput.prototype.displayedValues = function (onlyIncludeDirtyValues) {
                var displayedValues = {};
                if (!onlyIncludeDirtyValues || this.isDisplayedValueDirty()) {
                    displayedValues[this.Name] = this.displayedValue();
                }
                return displayedValues;
            };
            /**
             * The callback when the control gets focus as determined by the boundaryFocus binding handler
             * @param evt The focus in event
             */
            BaseInput.prototype.focusInCallBack = function (evt) {
                // Prevent focus on disabled controls (needed for IE bug #3216311)
                if (!$dyn.value(this.Enabled)) {
                    if (evt) {
                        evt.stopPropagation();
                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("focusIn on disabled input, control name: %s", this.Name);
                    }
                    return;
                }
                this.isFocused(true);
                $dyn.log.focus && $dyn.log.focus("Focus: input->focusInCallBack input name: %s", this.Name);
                if ($dyn.value(this.AllowEdit)) {
                    // Hide indicators on focus
                    this.StatusIndicator($dyn.ui.StatusIndicator.none);
                }
            };
            /**
             * The callback when the control loses focus as determined by the boundaryFocus binding handler
             * @param event The focus out event
             */
            BaseInput.prototype.focusOutCallBack = function (event) {
                var _this = this;
                this.updatingBlock(function () {
                    if (_this.isFocusOutTargetFlyout(event) || _this.isResizingInLookup(event)) {
                        // Focus is going into the hosted flyout. No-op.
                        return;
                    }
                    _this.isFocused(false);
                    $dyn.log.focus && $dyn.log.focus("Focus: input->focusOutCallBack input name: %s", _this.Name);
                    if (_this.uncommittedValue !== undefined) {
                        var forceChange = (_this.ChangeMode === $dyn.ui.ChangeMode.dirty);
                        $dyn.setValue(_this, "formattedValue", _this.uncommittedValue, forceChange);
                    }
                    if (!_this.ReferenceGroup) {
                        // Update the status area when the control is left unless the control is in a refgroup. In refgroup scenario, the refgroup itself will do this.
                        _this.UpdateStatusArea();
                    }
                    // A SetValue interaction could come from blur (typing the same value while changeMode=dirty)
                    // We need the SetValue to get sent before the request close of the lookup otherwise a disambiguation lookup
                    // could be presented to the user even though a lookup was already open.
                    $dyn.async(function () {
                        _this.focusOutCleanup();
                    });
                });
            };
            BaseInput.prototype.applyClientState = function (clientState) {
                if (clientState.formattedValue !== undefined && clientState.formattedValue !== this.getFormattedValue()) {
                    // Update the formatted value if it's different from the one stored in the Client State on the server
                    this.formattedValue(clientState.formattedValue);
                }
            };
            /**
             * Call the applicable text changed commands
             */
            BaseInput.prototype.callTextChanged = function () {
                if (($dyn.value(this.TextChanged) || this.textChangedInternal) && $dyn.value(this.AllowEdit)) {
                    $dyn.callFunction(this.TextChanged, this, [this.displayedValue()]);
                    $dyn.applyFunction(this.textChangedInternal, this);
                }
            };
            return BaseInput;
        }(controls.Edit));
        controls.BaseInput = BaseInput;
        BaseInput.prototype.PlaceHolder = "";
        BaseInput.prototype.IsHyperlink = false;
        BaseInput.prototype.LimitText = null;
        BaseInput.prototype.Alignment = "Left";
        BaseInput.prototype.PasswordMode = false;
        BaseInput.prototype.SipAddress = null;
        BaseInput.prototype.IsEmptyPassword = true;
        BaseInput.prototype.showToolTip = true;
        BaseInput.prototype.LookupOnly = false;
        BaseInput.prototype.ClientState = "";
        BaseInput.prototype.ChangeMode = $dyn.ui.ChangeMode.dirty;
        BaseInput.prototype.ExecuteHyperlink = null;
        BaseInput.prototype.SetValue = null;
        BaseInput.prototype.CustomPopup = null;
        BaseInput.prototype.RequestPopup = null;
        BaseInput.prototype.ShowFlyout = false;
        BaseInput.prototype.bindUpdate = true;
        BaseInput.prototype.recordability = $dyn.util.recordabilityDefault;
        $dyn.ui.addObservablePropertiesToPrototype(BaseInput.prototype, {
            Presence: null,
            Value: "",
        });
        // tslint:disable:object-literal-sort-keys
        var inputShortcuts = {
            Escape: {
                Keys: { keyCode: $dyn.ui.KeyCodes.esc },
                Handler: function (evt) {
                    if (evt) {
                        evt.preventDefault();
                    }
                    return false;
                },
                RecordTelemetry: false,
                ShowToUser: false,
            },
            KeyForLookup: {
                Keys: {
                    keyCode: $dyn.util.Lookup.KeysToSendToLookup
                },
                Handler: $dyn.controls.Edit.prototype.handleKeyDownForLookup,
                RecordTelemetry: false,
                ShowToUser: false,
            },
            HomeEnd: {
                Keys: { keyCode: [$dyn.ui.KeyCodes.home, $dyn.ui.KeyCodes.end] },
                Handler: function (evt) {
                    if ($dyn.value(this.AllowEdit) && this.isInGrid() && evt) {
                        evt.stopPropagation();
                    }
                    return false;
                },
                RecordTelemetry: false,
                ShowToUser: false,
            },
            SelectText: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.letterA },
                Handler: function (evt) {
                    if (evt && evt.target) {
                        $(evt.target).select();
                        return true;
                    }
                    return false;
                },
                RecordTelemetry: false,
                ShowToUser: false,
            },
            Backspace: {
                Keys: { keyCode: $dyn.ui.KeyCodes.backSpace },
                Handler: function () {
                    if (!$dyn.value(this.AllowEdit)) {
                        return true;
                    }
                    return false;
                },
                RecordTelemetry: false,
                ShowToUser: false,
            },
            CtrlEnter: {
                // $dyn.bindingHandlers.link adds a keydown handler that handles this event
                // Add entry so that shortcut can be discovered by end user
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function () { return false; },
                RecordTelemetry: false,
                ShowToUser: function () { return $dyn.value(this.showLink); },
                Description: $dyn.label("Input_ExecuteHyperlink")
            },
            OpenLookup: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.downArrow },
                Handler: function () {
                    if ($dyn.value(this.LookupButton) && this.allowUserChanges()) {
                        // Open the lookup if it is not already open. Otherwise set focus into the lookup.
                        this.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                        if ($dyn.log.popups) {
                            $dyn.log.popups("Popups: Alt+Down shortcut used to open/focus lookup for %s / %s; setting ShowFlyout to true; ShowFlyout currently equals %s", this.Name ? this.Name : "<unknown>", (this._element && this._element.id) ? this._element.id : "<unknown>", $dyn.peek(this.ShowFlyout));
                        }
                        this.openOrFocusLookup();
                        return true;
                    }
                    return false;
                },
                RecordTelemetry: false,
                ShowToUser: function () { return ($dyn.value(this.LookupButton) && this.allowUserChanges()); },
                Description: $dyn.label("Input_OpenDropDown")
            },
            ContextMenu: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.f10 },
                Handler: function (evt) {
                    if (evt) {
                        evt.preventDefault();
                        evt.target = this.element;
                        $dyn.contextMenu.openContextMenuHandler(evt, true);
                    }
                    return false;
                },
                RecordTelemetry: false,
                Description: $dyn.label("Input_OpenContextMenu")
            },
            EnhancedPreview: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.upArrow },
                Handler: function (evt) {
                    return $dyn.shell.previewManager.enhancedPreviewShortcutHandler(this, evt);
                },
                RecordTelemetry: false,
                ShowToUser: function () { return $dyn.value(this.CanHavePreview) && this.RequestEnhancedPreview ? true : false; },
                Description: $dyn.label("Input_OpenEnhancedPreview")
            },
            Skype: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterP },
                Handler: function () {
                    var _this = this;
                    var sipAddress = $dyn.value(this.SipAddress);
                    if (sipAddress && sipAddress in $dyn.skypeInteraction.subscriptionMap) {
                        var subscription = $dyn.skypeInteraction.subscriptionMap[sipAddress];
                        $.each(subscription.controls, function (index, control) {
                            if (control.inputControl === _this) {
                                if (control.qtip) {
                                    if (control.qtip.rendered) {
                                        control.qtip.toggle();
                                    }
                                    else {
                                        control.qtip.show();
                                    }
                                }
                                else {
                                    window.location.replace("sip:" + sipAddress);
                                }
                                return false;
                            }
                        });
                    }
                },
                ShowToUser: function () {
                    var sipAddress = $dyn.value(this.SipAddress);
                    return (sipAddress && sipAddress in $dyn.skypeInteraction.subscriptionMap);
                },
                Description: $dyn.label("Input_SkypeShortcut"),
            }
        };
        BaseInput.prototype.Shortcuts = $dyn.extendPrototype(BaseInput.prototype.Shortcuts, inputShortcuts);
        /**
         * Framework class for Input controls
         */
        var Input = /** @class */ (function (_super) {
            __extends(Input, _super);
            function Input() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Input.prototype.getFormattedValue = function () {
                if ($dyn.peek(this.IsValid) || this._lastUserValue === undefined) {
                    // For a simple input control the _parsedValue == formattedValue
                    return this._parsedValue;
                }
                else {
                    return this._lastUserValue;
                }
            };
            Input.prototype.setFormattedValue = function (userValue, forceChange, forceCommandCall) {
                if (forceChange === void 0) { forceChange = false; }
                if (forceCommandCall === void 0) { forceCommandCall = false; }
                this._lastUserValue = userValue;
                var result;
                if (forceChange || userValue !== this._parsedValue) {
                    // first remove any messages that were previously present
                    // this will purge notification of any issues with the
                    // control's value that caused validation failures that
                    // have since been fixed.
                    this.removeMessages();
                    if (this.ValueChanged) {
                        $dyn.callFunction(this.ValueChanged, this, userValue);
                    }
                    // Nothing to to decode for normal inputs, just set the Value property with the new value.
                    this._parsedValue = userValue;
                    if (this.ReferenceGroup && $dyn.peek(this.ReferenceGroup.isFocused)) {
                        this.ReferenceGroup.isChildDataDirty = true;
                    }
                    else {
                        // Set the forcechange flag, so that update with the blank value is allowed
                        forceChange = forceChange || ($dyn.value(this.PasswordMode) && !$dyn.value(this.IsEmptyPassword) && !userValue);
                        result = this.setValue(userValue, forceChange, forceCommandCall);
                    }
                }
                if (!result) {
                    result = $.Deferred();
                    result.resolve();
                }
                return result;
            };
            Input.prototype.displayedValue = function () {
                var displayedValue;
                if (this.$inputElement && this.$inputElement[0]) {
                    displayedValue = this.$inputElement[0].value;
                }
                else {
                    // this is the case for all the xLabel Types
                    displayedValue = $dyn.value(this.Value);
                }
                return displayedValue;
            };
            Input.prototype.compareToParsedValue = function (newValue) {
                return this._parsedValue === newValue;
            };
            Input.prototype.updateParsedValue = function (newValue) {
                // If the password mode is set then just show the dummy value
                if ($dyn.value(this.PasswordMode)) {
                    if (!$dyn.value(this.IsEmptyPassword) && !this.isInactiveCell()) {
                        this._parsedValue = $dyn.ui.PasswordString;
                    }
                    else {
                        this._parsedValue = "";
                    }
                }
                else {
                    this._parsedValue = newValue;
                }
            };
            Input.prototype.parsedValueToString = function () {
                return this._parsedValue ? this._parsedValue : "";
            };
            Input.prototype._formatAsDisplayValue = function (rawValue) {
                return rawValue;
            };
            Input.prototype.updateLastUserValue = function (newValue) {
                this._lastUserValue = newValue;
            };
            Input.prototype.lastValidFormattedValue = function () {
                return $dyn.value(this.Value);
            };
            return Input;
        }(BaseInput));
        controls.Input = Input;
        $dyn.adapter({ id: "Guid", controlType: "Input", template: "Input" });
        $dyn.adapter({ id: "InputSummary", controlType: "Input", template: "SummaryField" });
        $dyn.adapter({ id: "InputLabel", controlType: "Input", template: "Label" });
        $dyn.adapter({ id: "InputCardCell", controlType: "Input", template: "CardCell" });
        var InputCell = /** @class */ (function (_super) {
            __extends(InputCell, _super);
            function InputCell(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                // All cells are editable (because allow edit is not virtualized)
                _this.AllowEdit = $dyn.observable(true);
                return _this;
            }
            InputCell.prototype.updateValue = function () {
                return this._onChange();
            };
            InputCell.prototype.addMessage = function (messageId) {
                if (!this.messages) {
                    this.messages = [];
                }
                this.messages.push(messageId);
            };
            InputCell.prototype._onChange = function () {
                var isDirty = false;
                if (this._committedValue !== this.currentValue) {
                    isDirty = true;
                    this._committedValue = this.currentValue;
                    // Raise a retargeted "change" event
                    this.RaiseEvent($dyn.ui.ChangeEvent, {
                        bubbles: true,
                    });
                }
                return isDirty;
            };
            InputCell.prototype._setValue = function () {
                // Force the value to be dirty
                this._committedValue = undefined;
            };
            InputCell.prototype.GetState = function () {
                // todo: Check against value?
                return {
                    formattedValue: this.currentValue,
                    messages: this.messages
                };
            };
            InputCell.prototype.ApplyState = function (clientState) {
                var retVal = $.Deferred();
                var formattedValue = clientState && clientState.formattedValue;
                if (formattedValue !== undefined) {
                    this.currentValue = formattedValue;
                }
                retVal.resolve();
                return retVal;
            };
            InputCell.prototype.attached = function () {
                this._ = {};
                _super.prototype.attached.call(this);
                this._committedValue = this.currentValue;
                this.Value = $dyn.observable(this._committedValue);
            };
            Object.defineProperty(InputCell.prototype, "currentValue", {
                get: function () {
                    return this._.input.value;
                },
                set: function (value) {
                    this._.input.value = value;
                },
                enumerable: false,
                configurable: true
            });
            return InputCell;
        }(Input));
        controls.InputCell = InputCell;
        $dyn.ui.addPropertiesToPrototype(InputCell.prototype, {
            validating: { defaultValue: false, attribute: "data-dyn-validating" }
        });
        $dyn.cellAdapter({ id: "Input" });
        $dyn.cellAdapter({ id: "Input", controlType: "InputCell", type: $dyn.cellTypes.editor });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Input.js.map
